import { IHeadCategory } from '../types/promosPage';

export const ALL_PROMOS: IHeadCategory = {
  name: 'Посмотреть все акции',
  url: '/newbuilding-promo-search/',
  queryString: '',
};
